import { render } from "./back-in-stock-drawer-group.vue?vue&type=template&id=0e20415f"
import script from "./back-in-stock-drawer-group.vue?vue&type=script&lang=js"
export * from "./back-in-stock-drawer-group.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__